export type ContactCredit = {
    id: number,
    contactId: number,
    creditAmount: number,
    description: string,
    privateNote: string,
    invoiceId?: number,
    expires?: Date
}

export const DefaultContactCredit: ContactCredit = {
    id: 0,
    contactId: 0,
    creditAmount: 0,
    description: '',
    privateNote: ''
}

export type ContactCreditIndex = {
    [id: number]: ContactCredit
}

export const getAvailableContactCredits = (credits: ContactCredit[]) => {
    const creditsNotInvoiced = getNonInvoicedCredits(credits);
    return getNonExpiredCredits(creditsNotInvoiced);
}

export const getAvailableCreditsForInvoice = (invoiceId: number, credits: ContactCredit[]) => {
    const creditsNotExpired = getNonExpiredCredits(credits);
    return creditsNotExpired.filter(c => c.invoiceId === undefined || c.invoiceId === invoiceId);
}

export const getNonInvoicedCredits = (credits: ContactCredit[]) => {
    return credits?.filter(cred => !cred.invoiceId) ?? [];
}

export const getNonExpiredCredits = (credits: ContactCredit[]) => {
    return credits?.filter(cred => !cred.expires || (cred.expires > new Date())) ?? [];
}

export const getInvoicedContactCredits = (credits: ContactCredit[]) => 
    credits.filter(cred => cred.invoiceId !== undefined);

export const getExpiredContactCredits = (credits: ContactCredit[]) =>
    credits.filter(cred => !cred.invoiceId)
           .filter(cred => cred.expires && new Date(cred.expires) < new Date())